<template>
  <div v-if="noData" class="noData">
    {{ __('There are no debts for this apartment') }}
  </div>
  <div v-else>
    <div class="inner">
      <div
        class="select-contact"
        v-if="
          financialReportMode == 'list' &&
            !displayOnly &&
            contactsOptions.length > 0
        "
      >
        <span class="p-mx-2 title">{{ __('A tenant pays') }}:</span>
        <p-vue-dropdown
          :options="contactsOptions"
          :optionLabel="'ContactName'"
          :optionValue="ContactID"
          v-model="contactSelected"
          class="dropdown"
        >
          <template #value="{ value, placeholder}">
            <div class=" p-d-flex p-jc-between">
              <span class="value">{{
                value ? value.ContactName : placeholder
              }}</span>
              <span class="icon">
                <i-icon name="arrow" />
              </span>
            </div>
          </template>
        </p-vue-dropdown>
      </div>
      <List
        v-if="financialReportMode == 'list'"
        @showDetail="showDetails"
        :unitAccountData="unitAccountData"
      ></List>
      <Details
        v-if="financialReportMode == 'details'"
        :yearDetails="selectedData"
        :displayOnly="displayOnly"
        :close="() => setFinancialReportMode('list')"
        @addToPayment="addToPayment"
      ></Details>
      <PaymentTotal
        v-if="financialReportMode == 'payment-total'"
        @getBatchData="setBatchData"
        @saveHokChange="handleHokStatus"
        @hokDateChange="handleHokDateChange"
        @updateData="updateData"
        @ErrCreateTransactionTable="ErrCreateTransactionTable"
        :createHokPanel="createHokPanel"
        :contactId="contact"
      ></PaymentTotal>
      <CCTran
        v-if="financialReportMode == 'cc-tran'"
        tranType="token"
        :userID="userId"
        :contactID="contact"
        @tranResult="getTranResult"
      ></CCTran>
    </div>
    <div
      class="bottom"
      :class="lang.code"
      v-if="
        !displayOnly &&
          (financialReportMode == 'details' ||
            financialReportMode == 'payment-total' ||
            financialReportMode == 'contacts')
      "
    >
      <span class="total">{{
        __('Total payment: {0} NIS', [
          __u_value__({ value: total, unit: 'number-f' }),
        ])
      }}</span>
      <div
        class="floating-select-container"
        v-if="isDisplayPaymentSelect"
        v-click-outside="() => (isPaymentSelectOpen = false)"
      >
        <div class="floating-select-list" v-if="isPaymentSelectOpen">
          <div
            @click="
              () => {
                isChecks = false
                changeMode()
              }
            "
          >
            <p>
              {{ __('Pay by credit card') }}
            </p>
          </div>
          <div @click="goToChecksPage">
            <p>
              {{ __('Pay by checks') }}
            </p>
          </div>
        </div>
        <p-vue-button
          class="p-button-success rounded-light"
          :disabled="total <= 0"
          @click="toggleSelectPayment"
        >
          {{ __('Make a payment') }}
          <i
            class="pi "
            :class="{
              'pi-angle-up': !isPaymentSelectOpen,
              'pi-angle-down': isPaymentSelectOpen,
            }"
          ></i>
        </p-vue-button>
      </div>
      <template v-else>
        <p-vue-button
          v-if="isPayWithVisaAvailable"
          class="p-button-success p-button-rounded"
          @click="
            () => {
              isChecks = false
              changeMode()
            }
          "
        >
          {{ __('Go to payment') }}
        </p-vue-button>
        <p-vue-button
          :disabled="total <= 0"
          class="p-button-success p-button-rounded"
          v-if="isChecksDisplay && financialReportMode == 'details'"
          @click="goToChecksPage"
        >
          {{ __('Pay By Checks') }}
        </p-vue-button>
      </template>
      <!-- <div>
        <p-vue-button
          class="p-button-success p-button-rounded"
          @click="changeMode"
        >
          {{ __('Go to payment') }}
        </p-vue-button>
        <p-vue-button
          :disabled="total <= 0"
          class="p-button-success p-button-rounded"
          v-if="isChecksDisplay"
          @click="goToChecksPage"
        >
          {{ __('checks') }}
        </p-vue-button>
      </div> -->
    </div>
  </div>
  <i-override-dialog
    :modal="true"
    :dismissableMask="true"
    :title="resultTitle"
    :close="() => (showResult = false)"
    :style="{
      width: '100%',
      maxWidth: '320px',
    }"
    v-model:visible="showResult"
  >
    <div v-if="ErrorId">
      <p>{{ __('An error occurred while clearing credit') }}</p>
      <p>
        {{
          __('Please contact the management company at the telephone number: ')
        }}{{ CompanyPhone }}
      </p>
      <p>
        <b> {{ __('Error Details:') }} </b>
      </p>
      <p>{{ __('Date and time') }}:{{ dateFormat(new Date(), true) }}</p>
      <p>{{ __('Managment Company:') }}{{ CompanyName }}</p>
      <p>{{ __('Clearing code:') }} {{ BatchID }}</p>
      <p>{{ __('Last 4 digits of the card:') }} {{ cardLast4Digits }}</p>
      <p>{{ __('Error code:') }} {{ ErrorId }}</p>
      <p>{{ __('Error description:') }} {{ ErrorDesc }}</p>
    </div>
    <div v-else>
      <p>
        {{ __('Enter your email address to receive payment confirmations.') }}
      </p>
      <p-vue-input-text type="email" v-model="Email" style="width: 95%;" />
      <i-form-error :data="EmailError" />

      <div v-if="createHokPanel" class="createHokPanel">
        <hok-radio
          @updateData="updateData"
          :isSuccess="false"
          @saveHokChange="handleHokStatus"
          @hokDateChange="handleHokDateChange"
        />
      </div>

      <div class="p-d-flex p-jc-end p-mt-3">
        <p-vue-button
          class="p-button-outlined p-button-success p-button-rounded"
          @click="sendEmail"
        >
          <span class="p-button-text">{{ __('Send') }}</span>
        </p-vue-button>
      </div>
    </div>
  </i-override-dialog>
  <i-override-dialog
    :modal="true"
    :dismissableMask="true"
    :title="__('The building is not open for clearing')"
    :close="() => (showNoDealer = false)"
    :style="{
      width: '100%',
      maxWidth: '320px',
    }"
    v-model:visible="showNoDealer"
  >
    <p>
      {{
        __('To pay by credit card, contact {0} by phone:', [
          getResponsibleForCollectionName(),
        ])
      }}
      <a :href="c_link__('phone', [getResponsibleForCollectionPhone()])">
        <span>{{ getResponsibleForCollectionPhone() }}</span>
      </a>
      <!-- {{ __("To pay by credit card, contact APOINT by phone:") }}
      <a :href="c_link__('phone', '077')">
        <span>077</span>
      </a> -->
    </p>
  </i-override-dialog>
</template>

<script>
import List from './list'
import Details from './detail'
import CCTran from '@/components/CCTran'
import PaymentTotal from './payment-total'
import { callProc, apiParam, apiPType, dbFuncVal } from '@/services/APointAPI'
import { mapState } from 'vuex'
import { __c_link__ } from '@/includes/helper'
import { dateFormat, isValidEmail, errorReceived } from '@/services/apointUtil'
import { __ } from '@/plugins/i18n/index'
import HokRadio from './hok-radio.vue'

export default {
  components: {
    List,
    CCTran,
    Details,
    PaymentTotal,
    HokRadio,
  },
  plugins: { __ },
  data() {
    return {
      isBuildingValidToChex: false,
      isPaymentSelectOpen: false,
      currBuilding: null,
      unitAccountData: null,
      selectedData: null,
      total: 0,
      BatchID: 0,
      getStatus: true,
      BatchCCTranzCount: 0,
      showResult: false,
      StatusID: 0,
      resultTitle: __('The transaction was completed successfully'),
      Email: null,
      EmailError: null,
      CompanyName: null,
      CompanyPhone: null,
      noData: false,
      contact: null,
      contactGuid: null,
      displayOnly: false,
      year: null,
      ErrorId: null,
      ErrorDesc: null,
      showNoDealer: false,
      c_link__: __c_link__,
      createHokPanel: false,
      saveHok: null,
      hokDate: '1',
      limitToDate: null,
      minDate: null,
      dateFormat,
      cardLast4Digits: null,
      legalUnitModal: false,
      contactsOptions: [],
      contactSelected: null,
      chargeDay: null,
      windowWidth: window.innerWidth,
    }
  },
  created() {
    if (this.contact)
      this.$store.commit('setFinancialReportContact', this.contact)
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)

    // console.log("init nounted");
    this.setFinancialReportMode('list')
    if (this.$route.params.contactId) {
      // console.log("init if (this.$route.params.contactId) {");
      this.contact = this.$route.params.contactId
      callProc('isBuildingValidToChexByContact', [
        apiParam('ContactID', this.contact, apiPType.Int),
      ])
        .then((result) => {
          result = JSON.parse(result)
          this.isBuildingValidToChex = result.Table[0].isBuildingValidToChex
        })
        .catch((error) => {
          errorReceived(error)
        })
      // this.displayOnly = true;
    } else {
      this.displayOnly = true
      this.isBuildingValidToChex = false
    }
    // this.$store.commit('setFinancialReportContact', this.contact)
    this.getData()
    this.appHokExistsForContact()
    if (this.apartment) this.setContacts()
    // else this.displayOnly = true
  },
  methods: {
    handleIsLegalUnit() {
      const isLegalProc = this.legalUnit && this.appDoNotDisplayLegalUnits
      if (isLegalProc) {
        showSuccessOrFailedModal(
          __(
            'This unit is in legal proceedings and according to the policy of the management company, the payment must be arranged directly with the management company or the attending attorney.'
          ),
          5000,
          false
        )
      }
      return isLegalProc
    },
    async goToChecksPage() {
      if (this.handleIsLegalUnit()) return
      let platform = window.cordova.platformId
      if (platform === 'ios') {
        if (this.handleOpenWindow()) {
          return
        }
      }

      if (!this.contactGuid) {
        const contact = this.$store.getters.getFinancialReportContact
        console.log('🚀 ~ goToChecksPage ~ contact:', contact)
        if (contact) this.contactGuid = contact.ContactGuid
      }
      await this.$store.dispatch('loadChecks', {
        contactGuid: this.contactGuid,
      })
      if (this.checksGroupToDisplay.length === 1) {
        this.$router.push(
          `/checks/checksfill/${this.checksGroupToDisplay[0].ID}`
        )
        return
      }
      this.$store.commit('setInitiallyCommitted', { committed: false })
      this.$router.push({ name: 'ChecksPage' })
    },
    setContacts() {
      this.contactsOptions = this.apartment.renterContact.concat(
        this.apartment.ownerContact
      )
      this.contactsOptions.map(
        (c) => (c.ContactName = c.FirstName + ' ' + c.LastName)
      )
      if (this.contactsOptions.length > 0)
        this.contactSelected = this.contactsOptions[0]
    },
    getResponsibleForCollectionPhone() {
      return this.CompanyPhone
    },
    getResponsibleForCollectionName() {
      return this.CompanyName
    },
    updateData(key, value) {
      this[key] = value
    },
    ErrCreateTransactionTable() {
      this.setFinancialReportMode('details')
    },
    handleHokDateChange({ hokDate, limitToDate }) {
      this.hokDate = hokDate
      this.limitToDate = limitToDate
    },
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    handleHokStatus(hokStatus) {
      // console.log("handleHokStatus", hokStatus);
      this.saveHok = hokStatus
      if (hokStatus === false) {
        this.createHokPanel = true
        // console.log("createHokPanel", this.createHokPanel);
      }
    },
    getData() {
      let procParams = [
        apiParam('ContactID', this.contact, apiPType.Int),
        apiParam('theYr', new Date().getFullYear(), apiPType.Int),
        apiParam('theMon', new Date().getMonth() + 1, apiPType.Int),
      ]

      let procName = 'appListUnitAccountDataAll_V2'
      if (!this.contact) {
        procName = 'WorkerApp_ListUnitAccountDataAll_V2'
        procParams.push(apiParam('UID', this.apartment.UID, apiPType.Int))
      }
      callProc(procName, procParams)
        .then((result) => {
          result = JSON.parse(result)

          let data = result.Table.concat(result.Table1)
          if (data.length > 0) {
            this.noData = false
            let firstYear = data[0].Yr,
              lastYear = data[data.length - 1].Yr

            this.unitAccountData = []
            for (let index = firstYear; index <= lastYear; index++) {
              let yearData = data.filter((f) => f.Yr == index)
              let yearTotal = yearData.reduce((a, b) => a + b['Itra'], 0)
              if (yearTotal > 0)
                this.unitAccountData.push({
                  year: index,
                  report: yearData,
                  total: yearTotal,
                })
            }
            if (this.year && this.year != 0) {
              this.showDetails(
                this.unitAccountData.find((f) => f.year == this.year)
              )
            }
            // console.log(this.unitAccountData[0]);
            // this.userId = result.Table4[0].ccSystemUser;
            this.CompanyName = result.Table4[0]?.CompanyName
            this.CompanyPhone = result.Table4[0]?.CompanyPhone
            this.$store.commit('api/setSessionData', {
              dealerNumber: result.Table4[0]?.dealerNumber,
            })
            this.Email = result.Table4[0]?.ContactEmail
            if (result.Table4[0].PermWorkerClearing == 0 || !this.dealerNumber)
              this.displayOnly = true

            this.setFinancialReportMode('list')
            this.appGetSumFeeSelection()
          } else this.noData = true
          if (this.HokFiledChangeCard) {
            this.selectLastDebt()
          }
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    setBatchData(BatchID, BatchCCTranzCount) {
      this.BatchID = BatchID
      this.BatchCCTranzCount = BatchCCTranzCount
    },
    showDetails(item) {
      // console.log("Show Details", item);
      this.selectedData = item
      this.setFinancialReportMode('details')
    },
    addToPayment(event) {
      // let report = this.selectedData.report.find((f) => f.UFid == event.UFid);
      event.selected = !event.selected
      let procParams = [
        apiParam('ContactID', this.contact, apiPType.Int),
        apiParam('UFid', event.UFid, apiPType.Int),
        apiParam('UFIID', event.UFIID, apiPType.Int),
        apiParam('UpdateItra', event.Itra, apiPType.Real),
        apiParam('AddOrRemove', event.selected ? 1 : 0, apiPType.TinyInt),
      ]
      callProc('appUpdateFeeSelection_V2', procParams, 30)
        .then((result) => {
          result = JSON.parse(result)
          // console.log(result);
          this.total = result.Table[0].SumOfFees
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    appGetSumFeeSelection() {
      let procParams = [apiParam('ContactID', this.contact, apiPType.Int)]
      callProc('appGetSumFeeSelection', procParams)
        .then((result) => {
          result = JSON.parse(result)
          this.total = result.Table[0].SumOfFees
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    changeMode() {
      if (
        this.financialReportMode === 'payment-total' &&
        this.saveHok === null &&
        this.createHokPanel
      ) {
        return this.$toast.add({
          severity: 'error',
          detail: __(
            'It is mandatory to choose whether to keep credit card information'
          ),
          life: 3000,
        })
      }

      //Todo : ask dudi if this section should be handled as in tenant app ?
      if (this.financialReportMode == 'details') {
        this.setFinancialReportMode('payment-total')
        // else this.showNoDealer = true;
      } else if (this.financialReportMode == 'payment-total')
        this.setFinancialReportMode('cc-tran')
      else if (this.financialReportMode == 'contacts')
        this.setFinancialReportMode('list')
    },
    setFinancialReportMode(mode) {
      this.$store.commit('setFinancialReportMode', mode)
    },
    showSelectContact() {
      this.setFinancialReportMode('contacts')
      this.displayOnly = false
    },
    getTranResult(status, tokenID, cardLast4Digits) {
      this.cardLast4Digits = cardLast4Digits
      this.setFinancialReportMode('list')
      if (status == 'OK') this.appUpdateCardDataToBatch(tokenID)
    },
    appUpdateCardDataToBatch(tokenID) {
      this.$store.dispatch('doLoading', true)
      let procParams = [
        apiParam('BatchID', this.BatchID, apiPType.Int),
        apiParam('TokenID', tokenID, apiPType.Int),
      ]
      callProc('appUpdateCardDataToBatch', procParams)
        .then(() => {
          let i = 0
          this.appBatchStatus()
          let interval = setInterval(() => {
            i++
            if (this.getStatus && i < 50 * this.BatchCCTranzCount)
              this.appBatchStatus()
            else clearInterval(interval)
          }, 1000)
          this.appStartBatch()
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    appStartBatch() {
      let procParams = [
        apiParam('BatchID', this.BatchID, apiPType.Int),
        apiParam('UserID', this.userId, apiPType.Int),
      ]
      callProc('appStartBatch_V2', procParams).catch((error) => {
        errorReceived(error)
      })
      this.createHokPanel = !this.saveHok && this.createHokPanel
    },
    appBatchStatus() {
      let procParams = [apiParam('BatchID', this.BatchID, apiPType.Int)]
      callProc('appBatchStatus', procParams)
        .then((result) => {
          result = JSON.parse(result)
          if (result.Table[0].StatusID != 2 && result.Table[0].StatusID != 1) {
            this.$store.dispatch('doLoading', false)
            setTimeout(() => {
              this.getStatus = false
            }, 1000)
            this.showResult = true
            if (this.StatusID != result.Table[0].StatusID) {
              this.StatusID = result.Table[0].StatusID
              if (this.StatusID == 3) this.tenantAppGetResponseData()
            }
          }
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    tenantAppUnitContactSendReceipt() {
      this.$store.dispatch('doLoading', true)
      let procParams = [
        apiParam('UserNum', this.userId, apiPType.Int),
        apiParam('ContactID', this.contact, apiPType.Int),
        apiParam('BatchID', this.BatchID, apiPType.Int),
        apiParam('recipientEmail', this.Email, apiPType.VarChar),
        apiParam('TheErr', 0, apiPType.Int),
      ]
      callProc(
        'tenantAppUnitContactSendReceipt',
        procParams,
        undefined,
        undefined,
        undefined,
        40
      )
        .then((result) => {
          result = JSON.parse(result)

          this.$store.dispatch('doLoading', false)
          if (!result.Table) {
            if (!this.saveHok) {
              this.$store.dispatch('doLoading', false)

              this.$toast.add({
                severity: 'success',
                detail: __('The email was sent successfully'),
                life: 3000,
              })
              this.$router.push({ name: 'Apartments' })
            }
          } else
            this.$toast.add({
              severity: 'error',
              summary: __('Error sending email'),
              detail: __(
                'Make sure the email address is correct and try again, or contact the management company for the document.'
              ),
              life: 3000,
            })
          this.$store.dispatch('doLoading', false)
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    sendEmail() {
      // console.log("sendEmail", this.createHokPanel, this.saveHok);
      this.EmailError = null
      if (isValidEmail(this.Email)) {
        this.$store.dispatch('doLoading', true)
        this.tenantAppUnitContactSendReceipt()
        this.showResult = false
        if (this.saveHok) this.appSaveCCDataforFutureByContactID(true)
      } else this.EmailError = __('Enter a valid email address')
    },
    tenantAppGetResponseData() {
      let procParams = [apiParam('BatchID', this.BatchID, apiPType.Int)]
      callProc('tenantAppGetResponseData', procParams)
        .then((result) => {
          result = JSON.parse(result)
          // console.log(result);
          if (result.Table[0]?.tranResultCode == 0) {
            this.getData()
            this.resultTitle = __('The transaction was completed successfully')
            this.ErrorId = null
            this.ErrorDesc = null
            if (this.saveHok) this.appSaveCCDataforFutureByContactID(false)
            // console.log(
            //   "tenantAppGetResponseData",
            //   this.createHokPanel,
            //   this.saveHok
            // );
          } else {
            this.resultTitle = __('The transaction failed')
            this.ErrorId = result.Table[0]?.tranResultCode
            this.ErrorDesc = result.Table[0]?.tranResultMsg
          }
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    appHokExistsForContact() {
      const funcParams = [apiParam('ContactID', this.contact, apiPType.Int)]
      dbFuncVal('appHokExistsForContact', funcParams)
        .then((result) => {
          if (JSON.parse(result).funcResult == 0) {
            this.createHokPanel = true
            // console.log("appHokExistsForContact", this.createHokPanel);
            this.limitToDate = new Date()
            this.minDate = new Date()
            this.limitToDate.setMonth(this.limitToDate.getMonth() + 1)
            this.minDate.setMonth(this.minDate.getMonth() + 1)
          } else {
            this.createHokPanel = false
          }
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    appSaveCCDataforFutureByContactID(afterSendMail) {
      // console.log("appSaveCCDataforFutureByContactID", afterSendMail);
      let procParams = [
        apiParam('ContactId', this.contact, apiPType.Int),
        apiParam('UserID', this.userId, apiPType.Int),
        apiParam(
          'ValidTo',
          this.hokDate == 1 ? null : this.limitToDate,
          apiPType.DateTime
        ),
        apiParam('ChargeDay', +this.chargeDay, apiPType.Int),
      ]
      callProc(
        'appSaveCCDataforFutureByContactID',
        procParams,
        undefined,
        undefined,
        undefined,
        40
      )
        .then((result) => {
          result = JSON.parse(result)
          // console.log(result);
          this.$store.dispatch('doLoading', false)
          if (result.Table[0].ErrID == 0) {
            this.$toast.add({
              severity: 'success',
              detail: __(
                afterSendMail
                  ? 'The email was sent successfully and a standing order was established for you'
                  : 'a standing order was established for you'
              ),
              life: 3000,
            })
            if (afterSendMail) this.$router.push({ name: 'Apartments' })
            else {
              this.saveHok = false
            }
          } else {
            let detail = result.Table[0].errDescription
            if (result.Table[0].ErrID == -2) {
              let missingParams = ''
              if (result.Table[0].tokenId == 0) missingParams = 'tokenId'
              else if (result.Table[0].ccTokenNum == '')
                missingParams = 'ccTokenNum'

              detail = __('No value exists in the field') + ' ' + missingParams
            }
            errorReceived(
              __('A standing order has not been created'),
              result.Table[0],
              detail
            )
          }
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    selectLastDebt() {
      let procParams = [apiParam('ContactID', this.contact, apiPType.Int)]
      callProc('appAddAllPastDebtToPayment_V2', procParams)
        .then(() => {
          this.appGetSumFeeSelection()
          this.showDetails(this.unitAccountData[0])
          this.changeMode()
        })
        .catch((error) => {
          errorReceived(error)
        })
    },
    toggleSelectPayment() {
      this.isPaymentSelectOpen = !this.isPaymentSelectOpen
    },
  },
  computed: {
    ...mapState({
      financialReportMode: (state) => state.financialReportMode,
      vaadMenuItems: (state) => state.vaadMenuItems,
      isVaadMember: (state) => state.api.isVaadMember,
      dealerNumber: (state) => state.api.dealerNumber,
      HokFiledChangeCard: (state) => state.HokFiledChangeCard,
      legalUnit: (state) => state.api.legalUnit,
      appDoNotDisplayLegalUnits: (state) => state.appDoNotDisplayLegalUnits,
      userId: (state) => state.api.workerID,
      apartment: (state) => state.apartmentSelected,
      lang: (state) => state.local,
    }),
    isChecksDisplay() {
      return (
        this.windowWidth < 1000 &&
        this.isBuildingValidToChex &&
        !this.displayOnly
      )
    },
    isPayWithVisaAvailable() {
      return Boolean(this.dealerNumber)
    },
    isDisplayPaymentSelect() {
      return (
        this.isChecksDisplay &&
        this.isPayWithVisaAvailable &&
        this.financialReportMode != 'payment-total'
      )
    },
    checksGroupToDisplay() {
      return this.$store.getters.checks
    },
  },
  watch: {
    contactSelected() {
      this.contact = this.contactSelected.ContactID
      this.contactGuid = this.contactSelected.ContactGuid
      this.appHokExistsForContact()
      this.getData()
      this.setFinancialReportMode('list')
    },
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style scoped>
.inner {
  flex: 1;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.bottom {
  bottom: 0;
  z-index: 2;
  position: sticky;
  position: -webkit-sticky;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 10px 0;

  background-color: white;
  border-top: 1px solid var(--color-border);
}

.bottom:deep(a) {
  text-decoration: none;
}

.he.bottom:deep(.p-button) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.en.bottom:deep(.p-button) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.bottom .total {
  padding: 0 15px;

  font-size: 18px;
  line-height: 1.14;
  letter-spacing: 0.58px;
}

.noData {
  font-size: 30px;
  text-align: center;
  padding-top: 70px;
  color: var(--color-success);
}

.createHokPanel {
  padding-top: 30px;
}

.createHokPanel .hokDates {
  display: flex;
  margin: 10px 0;
  align-items: center;
}

.createHokPanel .hokDates:deep(.p-calendar) {
  width: 35%;
  margin-right: 15px;
}

label {
  margin-right: 15px;
}

.points {
  padding: 10px 25px;
}

.points:deep(.pi-check) {
  color: var(--color-success);
}

.icon:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}

.select-contact {
  gap: 15px;
  display: grid;
  grid-template-columns: 30% 66%;
  border-bottom: 1px solid var(--color-border);
  align-items: center;
}

.select-contact .title {
  font-size: 18px;
  line-height: 1.14;
  letter-spacing: 0.58px;
  color: var(--color-primary);
}
</style>
